import jsPDF from 'jspdf'
import { formatCurrency } from './currency'

export interface ReceiptLine {
  label: string
  value: string
}

export interface ReceiptOptions {
  title: string
  condominiumName?: string | null
  referenceId: string
  date?: string | null
  partyLabel: string
  partyName: string
  lines: ReceiptLine[]
  amount: number
  currency?: string
  descricao?: string | null
  fileName: string
}

export function generateReceiptPdf({
  title,
  condominiumName,
  referenceId,
  date,
  partyLabel,
  partyName,
  lines,
  amount,
  currency = 'MZN',
  descricao,
  fileName,
}: ReceiptOptions): void {
  const doc = new jsPDF({ unit: 'mm', format: 'a5' })
  const pageWidth = doc.internal.pageSize.getWidth()
  const marginX = 15
  let y = 18

  doc.setFontSize(16)
  doc.setFont('helvetica', 'bold')
  doc.text(condominiumName || 'Indlus', marginX, y)
  y += 8

  doc.setFontSize(13)
  doc.text(title, marginX, y)
  y += 8

  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.text(`Nº: ${referenceId.slice(0, 8).toUpperCase()}`, marginX, y)
  doc.text(
    `Data: ${date ? new Date(date).toLocaleDateString('pt-MZ') : new Date().toLocaleDateString('pt-MZ')}`,
    pageWidth - marginX,
    y,
    { align: 'right' }
  )
  y += 10

  doc.setDrawColor(200)
  doc.line(marginX, y, pageWidth - marginX, y)
  y += 10

  doc.setFontSize(11)
  doc.setFont('helvetica', 'bold')
  doc.text(partyLabel, marginX, y)
  y += 6
  doc.setFont('helvetica', 'normal')
  doc.text(partyName, marginX, y)
  y += 10

  lines.forEach((line) => {
    doc.setFont('helvetica', 'bold')
    doc.text(`${line.label}:`, marginX, y)
    doc.setFont('helvetica', 'normal')
    doc.text(line.value, marginX + 35, y)
    y += 7
  })

  y += 4
  doc.setDrawColor(200)
  doc.line(marginX, y, pageWidth - marginX, y)
  y += 10

  doc.setFontSize(13)
  doc.setFont('helvetica', 'bold')
  doc.text('Valor:', marginX, y)
  doc.text(
    formatCurrency(amount, currency),
    pageWidth - marginX,
    y,
    { align: 'right' }
  )
  y += 12

  if (descricao) {
    doc.setFontSize(9)
    doc.setFont('helvetica', 'bold')
    doc.text('Descrição:', marginX, y)
    y += 6
    doc.setFont('helvetica', 'normal')
    const split = doc.splitTextToSize(descricao, pageWidth - marginX * 2)
    doc.text(split, marginX, y)
    y += split.length * 5 + 6
  }

  y += 15
  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.text('_______________________________', marginX, y)
  y += 5
  doc.text('Assinatura', marginX, y)

  doc.save(fileName)
}
